import http from "./http";
import Service from "../Service";

export default class SellerGroupService extends Service {

	all(data) {
		return http.get("admin/providers/sellers/groups", {
			headers: this.getHeaders(),
			params: data
		});
	}

	load(id, data={}) {
		return http.get(`admin/providers/sellers/groups/${id}`, {
			headers: this.getHeaders(),
			params: data
		});
	}

	save(group, data) {
		return http.post(`admin/providers/sellers/groups/`, group, {
			headers: this.getHeaders(),
			params: data
		});
	}

	update(group) {
		return http.put(`admin/providers/sellers/groups/${group.id}`, group, {
			headers: this.getHeaders()
		});
	}

	remove(id) {
		return http.delete(`admin/providers/sellers/groups/${id}`, {
			headers: this.getHeaders()
		});
	}

	add_to_group(id, data) {
		return http.post(`admin/providers/sellers/groups/add/${id}`, data, {
			headers: this.getHeaders()
		});
	}

	remove_from_group(id, seller_id) {
		return http.delete(`admin/providers/sellers/groups/remove/${id}?seller_id=${seller_id}`, {
			headers: this.getHeaders()
		});
	}

	get_sellers(data) {
		return http.get("admin/sellers/", {
			headers: this.getHeaders(),
			params: data
		});
	}

}
